export default __webpack_public_path__ + "static/media/quiz-info.02254213.png";